export const conversionRate = {
  GT: {
    GT: 1,
    Kg: 1016.05,
    Lbs: 2240,
    ST: 1.12,
    T: 1.01605,
  },
  Kg: {
    GT: 0.9842065 / 1000,
    Kg: 1,
    Lbs: 2.20462,
    ST: 1.10231 / 1000,
    T: 0.001,
  },
  Lbs: {
    GT: 1 / 2240,
    Kg: 1 / 2.20462,
    Lbs: 1,
    ST: 0.0005,
    T: 1 / 2204.62,
  },
  ST: {
    GT: 1 / 1.12,
    Kg: 1000 / 1.10231,
    Lbs: 2000,
    ST: 1,
    T: 0.907184,
  },
  T: {
    GT: 0.9842065,
    Kg: 1000,
    Lbs: 2204.62,
    ST: 1.10231,
    T: 1,
  },
};
const PRECISION = 2;
export const QUANTITY_PRECISION = {
  Ctn: 0,
  DEFAULT: PRECISION,
  Ftruck: 0,
  GT: 3,
  Kg: 0,
  Lbs: 0,
  M3: PRECISION,
  ST: 3,
  T: 3,
  Unit: PRECISION,
  shipment: PRECISION,
};